export class DataTest {
    public static container = {
        pedido101256: { "Code": "Inf0000", "Description": "OK", "Productivity": [{ "Productivity Id": "3325" }], "Datos": [{ "Container": "KART0001", "Slots": 15, "Columns": 3, "Pick No": "PICKLIST-00000055", "Wave": "ENR00000052/WV-001", "Type": "Pedido", "Orders": [{ "Order Date": "2024-02-09", "Order No": "101256", "Slot": "KPOS0001.03", "Status": "Packing", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, "Instructions": [], "Containers": [{ "Container": "ORBT0125", "Client Box": "B1", "Closed": true, "Documents": [{ "Type": "LABEL", "Value": "https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/BoxLabels/ORBT0135_101256_04032024123437.pdf?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-10T22:36:18Z&st=2024-03-10T22:21:18Z&spr=https&sig=o9OrJInjLb827bsxoCJK%2F5fLGvQ1iaubd9rhVIBShAY%3D", "Date": "2024-03-10 22:21" }], "Content Lines": [{ "Item": "SKU1012", "Quantity": 1.0 }] }, { "Container": "ORBT0135", "Client Box": "B1", "Closed": true, "Documents": [{ "Type": "LABEL", "Value": "https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/BoxLabels/ORBT0135_101256_04032024123437.pdf?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-10T22:36:18Z&st=2024-03-10T22:21:18Z&spr=https&sig=o9OrJInjLb827bsxoCJK%2F5fLGvQ1iaubd9rhVIBShAY%3D", "Date": "2024-03-10 22:21" }], "Content Lines": [{ "Item": "SKU1022", "Quantity": 2.0 }] }, { "Container": "ORBT0239", "Client Box": "B1", "Closed": true, "Documents": [{ "Type": "LABEL", "Value": "https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/BoxLabels/ORBT0135_101256_04032024123437.pdf?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-10T22:36:18Z&st=2024-03-10T22:21:18Z&spr=https&sig=o9OrJInjLb827bsxoCJK%2F5fLGvQ1iaubd9rhVIBShAY%3D", "Date": "2024-03-10 22:21" }], "Content Lines": [{ "Item": "SKU1012", "Quantity": 1.0 }] }], "Incidences": [], "Documents": [], "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 0.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, { "Item": "SKU1022", "Description": "Libro Fuzzy", "Bar Codes": "30002", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, { "Item": "SKU1012", "Description": "WHITE CLIP", "Bar Codes": "", "Quantity": 2.0, "Quantity Packed": 0.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] }] }] },

        pedido101000: { "Code": "Inf0000", "Description": "OK", 
        "Productivity": [{ "Productivity Id": "3325" }], 
        "Datos": [{ "Container": "KART0001", "Slots": 15, "Columns": 3, "Pick No": "PICKLIST-00000055", "Wave": "ENR00000052/WV-001", "Type": "Pedido", 
        "Orders": [{ "Order Date": "2024-02-09", "Order No": "101000", "Slot": "KPOS0001.03", "Status": "Packing", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
        "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
        "Instructions": [], 
        "Containers": [
            { "Container": "ORBT0125", "Client Box": "B1", "Closed": true, 
           "Documents": [{ "Type": "LABEL", "Value": "https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/BoxLabels/ORBT0135_101256_04032024123437.pdf?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-10T22:36:18Z&st=2024-03-10T22:21:18Z&spr=https&sig=o9OrJInjLb827bsxoCJK%2F5fLGvQ1iaubd9rhVIBShAY%3D", "Date": "2024-03-10 22:21" }], 
           "Content Lines": [{ "Item": "SKU1012", "Quantity": 1.0 }] }, 
           { "Container": "ORBT0135", "Client Box": "B1", "Closed": true, 
           "Documents": [{ "Type": "LABEL", "Value": "https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/BoxLabels/ORBT0135_101256_04032024123437.pdf?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-10T22:36:18Z&st=2024-03-10T22:21:18Z&spr=https&sig=o9OrJInjLb827bsxoCJK%2F5fLGvQ1iaubd9rhVIBShAY%3D", "Date": "2024-03-10 22:21" }], 
           "Content Lines": [{ "Item": "SKU1022", "Quantity": 2.0 }] }, 
           { "Container": "ORBT0239", "Client Box": "B1", "Closed": true, 
           "Documents": [{ "Type": "LABEL", "Value": "https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/BoxLabels/ORBT0135_101256_04032024123437.pdf?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-10T22:36:18Z&st=2024-03-10T22:21:18Z&spr=https&sig=o9OrJInjLb827bsxoCJK%2F5fLGvQ1iaubd9rhVIBShAY%3D", "Date": "2024-03-10 22:21" }], 
           "Content Lines": [{ "Item": "SKU1012", "Quantity": 1.0 }] },
           { "Container": "ORBT0240", "Client Box": "B1", "Closed": false, 
           "Documents": [], 
           "Content Lines": [{ "Item": "SKU1009", "Quantity": 1.0 },{ "Item": "SKU1010", "Quantity": 3.0 }] },
           { "Container": "ORBT0241", "Client Box": "B1", "Closed": false, 
           "Documents": [], 
           "Content Lines": [{ "Item": "SKU1009", "Quantity": 1.0 },{ "Item": "SKU1012", "Quantity": 3.0 }] }

        ], 
        "Incidences": [], "Documents": [], 
        "Order Lines": [
            { "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 0.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, 
            { "Item": "SKU1022", "Description": "Libro Fuzzy", "Bar Codes": "30002", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, 
            { "Item": "SKU1012", "Description": "WHITE CLIP", "Bar Codes": "", "Quantity": 5.0, "Quantity Packed": 3.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] },
            { "Item": "SKU1009", "Description": "Articulo 1009", "Bar Codes": "20009", "Quantity": 3.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, 
            { "Item": "SKU1010", "Description": "Articulo 1010", "Bar Codes": "20009", "Quantity": 3.0, "Quantity Packed": 3.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, 
        ]}
        ] 
        }
        ]},


        trol0009: { "Code": "Inf0035", "Description": "Container 'TROL0009' selected for packaging", 
        "Productivity": [{ "Productivity Id": "3310" }], 
        "Datos": [
             { "Container": "TROL0009", "Slots": 0, "Columns": 0, "Pick No": "PICKLIST-00000068", "Type": "Unitario", "Wave": "ENR00000062/WV-001", 
             "Orders": [
                 { "Order Date": "2024-03-01", "Order No": "101356", "Slot": "TROL0009", "Status": "Packing", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
                 "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
                 "Instructions": [], 
                 "Containers": [
                     { "Container": "INCI0021", "Client Box": "", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }] }, 
                     { "Container": "ORBT0194", "Client Box": "B1", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }] }], 
                  "Incidences": [{ "Type": "TEC", "Quantity": 0 }], 
                  "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 1.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, 
                     "Instructions": [], "Incidences": [{ "Type": "DAM", "Quantity": 1.0 }] }] }, 
                 { "Order Date": "2024-03-01", "Order No": "101357", "Slot": "TROL0009", "Status": "Packing", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
                   "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
                   "Instructions": [], 
                   "Containers": [
                       { "Container": "ORBT0196", "Client Box": "B1", "Closed": true, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }] }], 
                    "Incidences": [], 
                    "Order Lines": [
                         { "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 1.0, "Quantity Packed": 1.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] }, 
                { "Order Date": "2024-03-01", "Order No": "101358", "Slot": "TROL0009", "Status": "Incidence", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
                  "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
                  "Instructions": [], 
                  "Containers": [
                     { "Container": "ORBT0205", "Client Box": "B1", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }] }], 
                  "Incidences": [{ "Type": "TEC", "Quantity": 0 }], 
                  "Order Lines": [ 
                    { "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 1.0, "Quantity Packed": 1.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] }, 
                { "Order Date": "2024-03-01", "Order No": "101359", "Slot": "TROL0009", "Status": "Incidence", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
                  "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
                  "Instructions": [], "Containers": [], "Incidences": [{ "Type": "DAT", "Quantity": 0 }], 
                  "Order Lines": [
                     { "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 1.0, "Quantity Packed": 0.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] }, 
                { "Order Date": "2024-03-01", "Order No": "101360", "Slot": "TROL0009", "Status": "Packing", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
                  "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
                  "Instructions": [], 
                  "Containers": [
                     { "Container": "ORBT0219", "Client Box": "B1", "Closed": true, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }] }], "Incidences": [], 
                  "Order Lines": [
                    { "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 1.0, "Quantity Packed": 1.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] },
                { "Order Date": "2024-03-01", "Order No": "101361", "Slot": "TROL0009", "Status": "Picked", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
                    "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
                    "Instructions": [], 
                    "Containers": [], "Incidences": [], 
                    "Order Lines": [
                      { "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 1.0, "Quantity Packed": 0.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] }
                ] }] },
        kart0001: { "Code": "Inf0035", "Description": "Container 'KART0001' selected for packaging", 
        "Productivity": [{ "Productivity Id": "3325" }], 
        "Datos": [{ "Container": "KART0001", "Slots": 15, "Columns": 3, "Pick No": "PICKLIST-00000055", "Type": "Multipedido", "Wave": "ENR00000052/WV-001", 
        "Orders": [
            { "Order Date": "2024-02-09", "Order No": "101254", "Slot": "KPOS0001.01", "Status": "Incidence", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
        "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
        "Instructions": [], "Containers": [{ "Container": "INCI0013", "Client Box": "", "Closed": false, 
        "Content Lines": [{ "Item": "SKU1008", "Quantity": 3.0 }, { "Item": "SKU1009", "Quantity": 2.0 }, { "Item": "SKU1010", "Quantity": 2.0 }] }], 
        "Incidences": [{ "Type": "", "Quantity": 0 }], 
        "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 3.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 3.0 }] }, 
        { "Item": "SKU1009", "Description": "PINK CANDLE", "Bar Codes": "20009", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, 
        { "Item": "SKU1010", "Description": "CHERRY CANDLE", "Bar Codes": "20010", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] }, 
        
        { "Order Date": "2024-02-09", "Order No": "101255", "Slot": "KPOS0001.02", "Status": "Incidence", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, 
        "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, 
        "Instructions": [], "Containers": [
            { "Container": "INCI0014", "Client Box": "", "Closed": false,  "Content Lines": [{ "Item": "SKU1011", "Quantity": 1.0 }, { "Item": "SKU1012", "Quantity": 2.0 }] }, 
            { "Container": "ORBT0130", "Client Box": "E1", "Closed": true, "Content Lines": [{ "Item": "SKU1008", "Quantity": 3.0 }, { "Item": "SKU1011", "Quantity": 1.0 }] }], 
        "Incidences": [{ "Type": "", "Quantity": 0 }], 
        "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 3.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, 
        { "Item": "SKU1011", "Description": "RED CLIP", "Bar Codes": "", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 1.0 }] }, { "Item": "SKU1012", "Description": "WHITE CLIP", "Bar Codes": "", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 2.0 }] }] }, { "Order Date": "2024-02-09", "Order No": "101256", "Slot": "KPOS0001.03", "Status": "Picked", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, "Instructions": [], "Containers": [{ "Container": "ORBT0125", "Client Box": "B1", "Closed": true, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }] }, { "Container": "ORBT0135", "Client Box": "B1", "Closed": true, "Content Lines": [{ "Item": "SKU1022", "Quantity": 2.0 }] }], "Incidences": [], "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 1.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, { "Item": "SKU1022", "Description": "Libro Fuzzy", "Bar Codes": "30002", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, { "Item": "SKU1012", "Description": "WHITE CLIP", "Bar Codes": "", "Quantity": 2.0, "Quantity Packed": 0.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }] }, { "Order Date": "2024-02-09", "Order No": "101257", "Slot": "KPOS0001.04", "Status": "Incidence", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "CTT", "Urgent": false, "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "Porto", "Ship-to Post Code": "4000-040", "Country": "Portugal" }, "Instructions": [], "Containers": [{ "Container": "INCI0025", "Client Box": "", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 2.0 }, { "Item": "SKU1037", "Quantity": 1.0 }] }, { "Container": "ORBT0124", "Client Box": "B1", "Closed": true, "Content Lines": [{ "Item": "SKU1022", "Quantity": 2.0 }] }, { "Container": "ORBT0195", "Client Box": "B1", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }, { "Item": "SKU1037", "Quantity": 1.0 }] }], "Incidences": [{ "Type": "", "Quantity": 0 }], "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 3.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 2.0 }] }, { "Item": "SKU1022", "Description": "Libro Fuzzy", "Bar Codes": "30002", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [] }, { "Item": "SKU1037", "Description": "Sobre blanco mediano", "Bar Codes": "20034", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 1.0 }] }] }, { "Order Date": "2024-02-09", "Order No": "101258", "Slot": "KPOS0001.05", "Status": "Incidence", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, "Instructions": [], "Containers": [{ "Container": "INCI0012", "Client Box": "", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 2.0 }, { "Item": "SKU1011", "Quantity": 2.0 }, { "Item": "SKU1012", "Quantity": 2.0 }] }, { "Container": "ORBT0120", "Client Box": "B1", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }] }], "Incidences": [{ "Type": "", "Quantity": 0 }], "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 3.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 2.0 }] }, { "Item": "SKU1011", "Description": "RED CLIP", "Bar Codes": "", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 2.0 }] }, { "Item": "SKU1012", "Description": "WHITE CLIP", "Bar Codes": "", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 2.0 }] }] }, { "Order Date": "2024-02-09", "Order No": "101259", "Slot": "KPOS0001.06", "Status": "Incidence", "Delivery Type": "HOME", "Channel": "COSMOS", "Carrier": "MRW", "Urgent": false, "Ship To": { "Ship-to Name": "dS3BmKe48h", "Ship-to Name 2": "", "Ship-to Address": "dS3BmKe48hAddr", "Ship-to Address 2": "", "Ship-to City": "MADRID", "Ship-to Post Code": "28001", "Country": "España" }, "Instructions": [], "Containers": [{ "Container": "INCI0011", "Client Box": "", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 2.0 }, { "Item": "SKU1036", "Quantity": 1.0 }, { "Item": "SKU1037", "Quantity": 1.0 }] }, { "Container": "ORBT0119", "Client Box": "B1", "Closed": false, "Content Lines": [{ "Item": "SKU1008", "Quantity": 1.0 }, { "Item": "SKU1036", "Quantity": 1.0 }, { "Item": "SKU1037", "Quantity": 1.0 }] }], "Incidences": [{ "Type": "TEC", "Quantity": 0 }], "Order Lines": [{ "Item": "SKU1008", "Description": "WHITE CANDLE", "Bar Codes": "20008", "Quantity": 3.0, "Quantity Packed": 3.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 2.0 }] }, { "Item": "SKU1036", "Description": "Boli azul PILOT", "Bar Codes": "4902505", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 1.0 }] }, { "Item": "SKU1037", "Description": "Sobre blanco mediano", "Bar Codes": "20034", "Quantity": 2.0, "Quantity Packed": 2.0, "Quantity Registered": 0.0, "Instructions": [], "Incidences": [{ "Type": "MIS", "Quantity": 1.0 }] }] }, { "Slot": "KPOS0001.07" }, { "Slot": "KPOS0001.08" }, { "Slot": "KPOS0001.09" }, { "Slot": "KPOS0001.10" }, { "Slot": "KPOS0001.11" }, { "Slot": "KPOS0001.12" }, { "Slot": "KPOS0001.13" }, { "Slot": "KPOS0001.14" }, { "Slot": "KPOS0001.15" }] }] },

        trol0010: {
            "Code": "Inf0035",
            "Description": "Container 'TROL0010' selected for packaging",
            "Productivity": [
                {
                    "Productivity Id": "3437"
                }
            ],
            "Datos": [
                {
                    "Container": "TROL0010",
                    "Slots": 0,
                    "Columns": 0,
                    "Pick No": "PICKLIST-00000071",
                    "Type": "Unitario",
                    "Wave": "ENR00000066/WV-001",
                    "Orders": [
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101416",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0221",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101417",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0222",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101418",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0223",
                                    "Client Box": "B1",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 2.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 2.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101419",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0225",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                },
                                {
                                    "Container": "ORBT0226",
                                    "Client Box": "B1",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 2.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101420",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0227",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                },
                                {
                                    "Container": "ORBT0228",
                                    "Client Box": "B1",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 2.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101421",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "INCI0033",
                                    "Client Box": "",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": [
                                        {
                                            "Type": "DAM",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101422",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "INCI0034",
                                    "Client Box": "",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": [
                                        {
                                            "Type": "DAM",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101423",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0229",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101424",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0230",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101425",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0231",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101426",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0232",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101427",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "INCI0035",
                                    "Client Box": "",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": [
                                        {
                                            "Type": "DAM",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101428",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "INCI0036",
                                    "Client Box": "",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": [
                                        {
                                            "Type": "DAM",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101429",
                            "Slot": "TROL0010",
                            "Status": "Incidence",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "INCI0037",
                                    "Client Box": "",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": [
                                        {
                                            "Type": "DAM",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101430",
                            "Slot": "TROL0010",
                            "Status": "Incidence",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [
                                {
                                    "Type": "TEC",
                                    "Quantity": 0
                                }
                            ],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101431",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101432",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101433",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101434",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0249",
                                    "Client Box": "B2",
                                    "Closed": false,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101435",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101436",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101437",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101438",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101439",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101440",
                            "Slot": "TROL0010",
                            "Status": "Packing",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [
                                {
                                    "Container": "ORBT0224",
                                    "Client Box": "B1",
                                    "Closed": true,
                                    "Content Lines": [
                                        {
                                            "Item": "SKU1008",
                                            "Quantity": 1.0
                                        }
                                    ]
                                }
                            ],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU1008",
                                    "Description": "WHITE CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 1.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101441",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU2000",
                                    "Description": "GREEN CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        },
                        {
                            "Order Date": "2024-03-07",
                            "Order No": "101442",
                            "Slot": "TROL0010",
                            "Status": "Picked",
                            "Delivery Type": "HOME",
                            "Channel": "COSMOS",
                            "Carrier": "MRW",
                            "Urgent": false,
                            "Ship To": {
                                "Ship-to Name": "dS3BmKe48h",
                                "Ship-to Name 2": "",
                                "Ship-to Address": "dS3BmKe48hAddr",
                                "Ship-to Address 2": "",
                                "Ship-to City": "MADRID",
                                "Ship-to Post Code": "28001",
                                "Country": "España"
                            },
                            "Instructions": [],
                            "Containers": [],
                            "Incidences": [],
                            "Order Lines": [
                                {
                                    "Item": "SKU2000",
                                    "Description": "GREEN CANDLE",
                                    "Bar Codes": "20008",
                                    "Quantity": 1.0,
                                    "Quantity Packed": 0.0,
                                    "Quantity Registered": 0.0,
                                    "Instructions": [],
                                    "Incidences": []
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 

        trol0013: {"Code":"Inf0035","Description":"Container 'TROL0013' selected for packaging","Productivity":[{"Productivity Id":"3456"}],"Datos":[{"Container":"TROL0013","Slots":0,"Columns":0,"Pick No":"PICKLIST-00000076","Type":"Unitario","Wave":"ENR00000071/WV-001","Orders":[{"Order Date":"2024-03-15","Order No":"101466","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1008","Description":"WHITE CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101467","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1008","Description":"WHITE CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101468","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1008","Description":"WHITE CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101469","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1008","Description":"WHITE CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101470","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1006","Description":"GREEN CANDLE","Bar Codes":"20006","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101471","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1006","Description":"GREEN CANDLE","Bar Codes":"20006","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101472","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1006","Description":"GREEN CANDLE","Bar Codes":"20006","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101473","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1006","Description":"GREEN CANDLE","Bar Codes":"20006","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101474","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1006","Description":"GREEN CANDLE","Bar Codes":"20006","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101475","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1009","Description":"PINK CANDLE","Bar Codes":"20009","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101476","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1009","Description":"PINK CANDLE","Bar Codes":"20009","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101477","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1009","Description":"PINK CANDLE","Bar Codes":"20009","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101478","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1009","Description":"PINK CANDLE","Bar Codes":"20009","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101479","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1009","Description":"PINK CANDLE","Bar Codes":"20009","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101480","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1010","Description":"CHERRY CANDLE","Bar Codes":"20010","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101481","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1010","Description":"CHERRY CANDLE","Bar Codes":"20010","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101482","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1010","Description":"CHERRY CANDLE","Bar Codes":"20010","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101483","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1010","Description":"CHERRY CANDLE","Bar Codes":"20010","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101484","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"SKU1010","Description":"CHERRY CANDLE","Bar Codes":"20010","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101485","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"S22-0141-002-50700","Description":"CAMISA KIM","Bar Codes":"8434355327130","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101486","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"S22-0141-002-50700","Description":"CAMISA KIM","Bar Codes":"8434355327130","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101487","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"S22-0141-002-50700","Description":"CAMISA KIM","Bar Codes":"8434355327130","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101488","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Order Lines":[{"Item":"S22-0141-002-50700","Description":"CAMISA KIM","Bar Codes":"8434355327130","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101465","Slot":"TROL0013","Status":"Packed","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[{"Container":"ORBT0261","Client Box":"B1","Closed":true,"Content Lines":[{"Item":"SKU1008","Quantity":1.0}]}],"Incidences":[],"Order Lines":[{"Item":"SKU1008","Description":"WHITE CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":1.0,"Quantity Registered":1.0,"Instructions":[],"Incidences":[]}]},{"Order Date":"2024-03-15","Order No":"101489","Slot":"TROL0013","Status":"Packed","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[{"Container":"ORBT0262","Client Box":"B1","Closed":true,"Content Lines":[{"Item":"S22-0141-002-50700","Quantity":1.0}]}],"Incidences":[],"Order Lines":[{"Item":"S22-0141-002-50700","Description":"CAMISA KIM","Bar Codes":"8434355327130","Quantity":1.0,"Quantity Packed":1.0,"Quantity Registered":1.0,"Instructions":[],"Incidences":[]}]}]}]},
        pedido101466: {"Code":"Inf0000","Description":"OK","Productivity":[{"Productivity Id":"3456"}],"Datos":[{"Container":"TROL0013","Slots":0,"Columns":0,"Pick No":"PICKLIST-00000076","Wave":"ENR00000071/WV-001","Type":"Pedido","Orders":[{"Order Date":"2024-03-15","Order No":"101466","Slot":"TROL0013","Status":"Picked","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Documents":[],"Order Lines":[{"Item":"SKU1008","Description":"WHITE CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]}]}]},
        pedido101431: {"Code":"Inf0000","Description":"OK","Productivity":[{"Productivity Id":"3437"}],"Datos":[{"Container":"","Slots":0,"Columns":0,"Pick No":"","Type":"Pedido","Wave":"","Orders":[{"Order Date":"2024-03-07","Order No":"101431","Slot":"BF.PICKED","Status":"Packed","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Documents":[],"Order Lines":[{"Item":"SKU1008","Description":"WHITE CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]}]}]},
        pedido101441: {"Code":"Inf0000","Description":"OK","Productivity":[{"Productivity Id":"3437"}],"Datos":[{"Container":"","Slots":0,"Columns":0,"Pick No":"","Type":"Pedido","Wave":"","Orders":[{"Order Date":"2024-03-07","Order No":"101441","Slot":"BF.PICKED","Status":"Packed","Delivery Type":"HOME","Channel":"COSMOS","Carrier":"MRW","Urgent":false,"Ship To":{"Ship-to Name":"dS3BmKe48h","Ship-to Name 2":"","Ship-to Address":"dS3BmKe48hAddr","Ship-to Address 2":"","Ship-to City":"MADRID","Ship-to Post Code":"28001","Country":"España"},"Instructions":[],"Containers":[],"Incidences":[],"Documents":[],"Order Lines":[{"Item":"SKU2000","Description":"GREEN CANDLE","Bar Codes":"20008","Quantity":1.0,"Quantity Packed":0.0,"Quantity Registered":0.0,"Instructions":[],"Incidences":[]}]}]}]}
    };

    public static obtenerContenedorEmpaquetadoResponse = { "Code": "Inf0000", "Description": "OK", "Datos": [{ "Id": "B1", "Description": "Small Client Box 1", "High": 7.0, "Width": 10.0, "Length": 11.0, "Max Volume": 77.0, "Max Weight": 4.0, "Box": " ", "Bar Code": "" }, { "Id": "B2", "Description": "Big Client Box 2", "High": 8.0, "Width": 15.0, "Length": 22.0, "Max Volume": 0.0, "Max Weight": 10.0, "Box": " ", "Bar Code": "" }, { "Id": "E1", "Description": "Small Envelope AK-12", "High": 215.0, "Width": 120.0, "Length": 0.0, "Max Volume": 26.0, "Max Weight": 0.0, "Box": " ", "Bar Code": "" }, { "Id": "E2", "Description": "Big Envelope AK-15", "High": 265.0, "Width": 220.0, "Length": 0.0, "Max Volume": 58.0, "Max Weight": 0.0, "Box": " ", "Bar Code": "" }] }

    public static leerProductoSKU1018 = { "Code": "Inf0042", "Description": "Quantity '1' of 'SKU1008' moved from container 'KPOS0001.03' to 'ORBT0239'", "Productivity": [{ "Productivity Id": "3325" }], "Datos": [{ "Order Status": "Packing" }] }
    public static leerProductoSKU2000 = { "Code": "Inf0042", "Description": "Quantity '1' of 'SKU2000' moved from container 'KPOS0001.03' to 'ORBT0239'", "Productivity": [{ "Productivity Id": "3325" }], "Datos": [{ "Order Status": "Packing" }] }

    public static crearCaja = { "Code": "Inf0038", "Description": "Box selected and container created.", "Productivity": [{ "Productivity Id": "3325" }], "Datos": [{ "Container Id": "ORBT0246" }] }

    public static cambiarCaja = {"Code":"Inf0052","Description":"Box updated to 'E1' in container 'ORBT0289'","Productivity":[{"Productivity Id":"3495"}]}

    public static cerrarCaja = {"Code":"Inf0089","Description":"Order '101259' closed with incidences",
    "Productivity":[{"Productivity Id":"3325"}],
    "Datos":[{"Documents":[{"Type":"REPORT",
    "Value":"https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/BoxLabels/https://cosmoseaifiles.blob.core.windows.net/wms/SBCosmos/ORBIT/IncidenceReports/101259_17032024181310.pdf?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-17T18:28:12Z&st=2024-03-17T18:13:12Z&spr=https&sig=JFfvd%2BmdMRyh%2FthQ3P06TQoSD1a7MKK6lnef5h45yEQ%3D?sv=2022-11-02&ss=b&srt=o&sp=rw&se=2024-03-17T18:28:12Z&st=2024-03-17T18:13:12Z&spr=https&sig=JFfvd%2BmdMRyh%2FthQ3P06TQoSD1a7MKK6lnef5h45yEQ%3D",
    "Date":"2024-03-17 18:13"}]}]}
}